import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "remove",
  "use": "remove-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"remove\">\n<title>remove</title>\n<path d=\"M18.984 12.984h-13.969v-1.969h13.969v1.969z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol